import { render } from "./index.vue?vue&type=template&id=0a251bd6&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=0a251bd6&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a251bd6"],['__file',"src/views/SignUp/componets/Step4/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0a251bd6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0a251bd6', __exports__)) {
    api.reload('0a251bd6', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=0a251bd6&scoped=true", () => {
    api.rerender('0a251bd6', render)
  })

}


export default __exports__